import { render, staticRenderFns } from "./TradeMasterDetails.vue?vue&type=template&id=4c681c68"
import script from "./TradeMasterDetails.vue?vue&type=script&lang=js"
export * from "./TradeMasterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports